import { useEffect, useState } from 'react';
import { articleApi, Article } from '@/modules/articles/export';
import { Page } from '@/shared/pagination/export';
import { Card, Col, Row } from 'react-bootstrap';
import dayjs from 'dayjs';

export function DeepDiveAnalysisList() {
  const [articles, setArticles] = useState<Page<Article>>();

  useEffect(() => {
    articleApi
      .getArticlesBySection(undefined, {
        includeGenres: ['mni-section:519011417', 'mni-section:538093846'],
        limit: 9,
      })
      .then(setArticles);
  }, []);

  return (
    <div className={'mt-2'}>
      <Row
        className="d-flex flex-wrap justify-content-evenly align-content-stretch"
        style={{ height: '250px' }}
      >
        {articles?.content.map(article => (
          <Col md={4} key={article.uri} className={' mb-4 h-100 '}>
            <Card className={'h-100'}>
              <Card.Header>
                <h4>{article.headline}</h4>
                <small>
                  {dayjs(article.versioncreated).format('YYYY-MM-DD')} (
                  {dayjs(article.versioncreated).fromNow()})
                </small>
              </Card.Header>
              <Card.Body className={'overflow-hidden'}>
                {article.summary || article.body_text}
              </Card.Body>
              <Card.Footer>{article.byline}</Card.Footer>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
}
